import UserLayout from "../../components/UserLayout";
import CreateAdvertisement from "../../components/user/CreateAdvertisement";

const CreateAdvertisementPage = () => {
    return (
        <UserLayout>
            <CreateAdvertisement />
        </UserLayout>
    );
}

export default CreateAdvertisementPage;